/**
 * Download table rows as a SpreadsheetML .xls file Excel can open.
 * No extra npm dependency. Exports every provided row (not just the current page).
 */
import { displayLabel } from './columnLabels';
import { excelColumnValue } from './tableColumnDisplay';


function xmlEscape(value) {
  return String(value ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

function cellXml(value) {
  if (value == null || value === '') {
    return '<Cell><Data ss:Type="String"></Data></Cell>';
  }
  if (typeof value === 'number' && Number.isFinite(value)) {
    return `<Cell><Data ss:Type="Number">${value}</Data></Cell>`;
  }
  if (typeof value === 'boolean') {
    return `<Cell><Data ss:Type="String">${value ? 'true' : 'false'}</Data></Cell>`;
  }
  const raw = String(value);
  if (/^-?\d+(\.\d+)?$/.test(raw.trim())) {
    return `<Cell><Data ss:Type="Number">${raw.trim()}</Data></Cell>`;
  }
  return `<Cell><Data ss:Type="String">${xmlEscape(raw)}</Data></Cell>`;
}

function safeFilename(name) {
  const base = String(name || 'report')
    .replace(/[\\/:*?"<>|]+/g, '-')
    .replace(/\s+/g, '_')
    .slice(0, 80);
  return base || 'report';
}

export function buildExcelXml(columns, rows) {
  const cols = (columns || []).filter((c) => c && c.key);
  const data = Array.isArray(rows) ? rows : [];
  const header = cols
    .map((c) => `<Cell><Data ss:Type="String">${xmlEscape(displayLabel(c))}</Data></Cell>`)
    .join('');
  const body = data
    .map((row) => {
      const cells = cols.map((c) => cellXml(excelColumnValue(row, c)));
      return `<Row>${cells.join('')}</Row>`;
    })
    .join('\n');

  return `<?xml version="1.0" encoding="UTF-8"?>
<?mso-application progid="Excel.Sheet"?>
<Workbook xmlns="urn:schemas-microsoft-com:office:spreadsheet"
 xmlns:ss="urn:schemas-microsoft-com:office:spreadsheet">
<Worksheet ss:Name="Sheet1">
<Table>
<Row>${header}</Row>
${body}
</Table>
</Worksheet>
</Workbook>`;
}

export function exportTableExcel({ filename, columns, rows }) {
  const xml = buildExcelXml(columns, rows);
  const blob = new Blob(['\uFEFF', xml], { type: 'application/vnd.ms-excel;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `${safeFilename(filename)}.xls`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
